import axios, {AxiosRequestConfig} from "axios";
import {scopes, msalInstance} from "./msal";

const instance = axios.create({
    baseURL: process.env.REACT_APP_BaseApiUrl + '/api'
});

instance.interceptors.request.use(
    async (config: AxiosRequestConfig) => {
        if (config.headers) {
            config.headers['Content-Type'] = 'application/json';
        }

        //console.log("in instance.interceptors.request.use");
        //console.log("uri", instance.getUri());

        const account = msalInstance.getAllAccounts()[0];
        if (account) {
            const accessTokenResponse = await msalInstance.acquireTokenSilent({
                scopes: scopes,
                account: account
            })
            .catch(() => msalInstance.acquireTokenRedirect({
                scopes: scopes,
                account: account
            }));

            console.log("accessTokenResponse", accessTokenResponse);

            if (accessTokenResponse) {
                const tokenValue = process.env.REACT_APP_AuthorizationBearerToken === "id" ? accessTokenResponse.idToken : accessTokenResponse.accessToken;                    
                if (config.headers && tokenValue) {
                    config.headers['Authorization'] = 'Bearer ' + tokenValue;
                }
            }
        }
        return config;
    },
    error => {
        Promise.reject(error)
    });

export default instance;